import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preload hero image BEFORE React renders — browser starts fetching immediately
const preloadLink = document.createElement('link');
preloadLink.rel = 'preload';
preloadLink.as = 'image';
preloadLink.type = 'image/webp';
preloadLink.href = 'https://cdn.magicpatterns.com/uploads/ofPY8ZEeCjA6SqsAuD1cbc/3.webp';
document.head.appendChild(preloadLink);
// Preconnect to CDN and Google Fonts
const preconnectCDN = document.createElement('link');
preconnectCDN.rel = 'preconnect';
preconnectCDN.href = 'https://cdn.magicpatterns.com';
document.head.appendChild(preconnectCDN);
const preconnectFonts = document.createElement('link');
preconnectFonts.rel = 'preconnect';
preconnectFonts.href = 'https://fonts.gstatic.com';
preconnectFonts.crossOrigin = 'anonymous';
document.head.appendChild(preconnectFonts);
(function (c: any, l: any, a: string, r: string, i: string) {
  c[a] = c[a] || function () {
    ;
    (c[a].q = c[a].q || []).push(arguments);
  };
  const t = l.createElement(r) as HTMLScriptElement;
  t.async = true;
  t.src = 'https://www.clarity.ms/tag/' + i;
  document.head.appendChild(t);
})(window, document, 'clarity', 'script', 'vnoqdek95m');
render(<App data-id="element-422" />, document.getElementById('root'));